import { render } from "./HeadingField.vue?vue&type=template&id=3bfdcfa4"
import script from "./HeadingField.vue?vue&type=script&lang=js"
export * from "./HeadingField.vue?vue&type=script&lang=js"

import exportComponent from "/Users/david/Documents/GitHub/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeadingField.vue"]])

export default __exports__